module.exports = __webpack_public_path__ + "static/media/8.21212c8f.jpg";